import { toAlphaNumerics } from "common/utils/utils"
import { FORMAS_DE_CONTACTO } from "features/Contactos/constants"

export default ({
  nif,
  razonSocial,
  calle,
  codigoPostal,
  poblacionId,
  poblacionNombre,
  telefonos = [],
  emails = [],
  camposPersonalizados = [],
}: $TSMigrationFixMe) => ({
  direccion: {
    calle,
    codigoPostal,
    poblacionId,
    poblacionNombre,
  },
  formasContacto: [
    // @ts-expect-error TS(7006): Parameter 'contacto' implicitly has an 'any' type.
    ...telefonos.map((contacto) => ({
      contacto,
      tipoFormaContacto: FORMAS_DE_CONTACTO.TELEFONO,
    })),
    // @ts-expect-error TS(7006): Parameter 'contacto' implicitly has an 'any' type.
    ...emails.map((contacto) => ({
      contacto,
      nombre: "",
      tipoFormaContacto: FORMAS_DE_CONTACTO.EMAIL,
    })),
  ],
  nif: toAlphaNumerics(nif),
  razonSocial,
  camposPersonalizados,
})

export const importMapContacto = ({
  nif,
  razonSocial,
  calle,
  codigoPostal,
  poblacionId,
  poblacionNombre,
  telefonos = [],
  emails = [],
  camposPersonalizados = [],
}: $TSMigrationFixMe) => ({
  direccion: {
    calle,
    codigoPostal,
    poblacionId,
    poblacionNombre,
  },
  formasContacto: [
    // @ts-expect-error TS(7006): Parameter 'contacto' implicitly has an 'any' type.
    ...telefonos.map((contacto) => ({
      ...contacto,
    })),
    // @ts-expect-error TS(7006): Parameter 'contacto' implicitly has an 'any' type.
    ...emails.map((contacto) => ({
      ...contacto,
    })),
  ],
  nif: toAlphaNumerics(nif),
  razonSocial,
  camposPersonalizados,
})
